module.exports = __webpack_public_path__ + "img/BVBANK.f085b962.svg";